import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/shadcn/components/ui/dialog';
import { ScrollablePage } from '../Shared/ScrollablePage';
import { CarVinDecoder } from '../CustomerPage/CarVinDecoder';
import { Button } from 'src/shadcn/components/ui/button';

export interface ICarViewVinDecodeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  vin: string;
}

export const CarViewVinDecodeDialog: React.FunctionComponent<
  ICarViewVinDecodeDialogProps
> = ({ open, onOpenChange, vin }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button variant={'ghost'}>
          <span>Decode</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Vin decode {vin}</DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <ScrollablePage>
          <div className='mt-8 max-h-[80vh] w-full pb-20'>
            <CarVinDecoder vin={vin} />
          </div>
        </ScrollablePage>
      </DialogContent>
    </Dialog>
  );
};
